import Vue from 'vue'
import App from '@/App'
import store from '@/store'
import { LayoutPlugin, ImagePlugin } from 'bootstrap-vue'
import { ClickOutside } from '@/directives'

import '@/main.scss'

Vue.config.productionTip = false
Vue.use(LayoutPlugin)
Vue.use(ImagePlugin)
Vue.directive('click-outside', ClickOutside)

new Vue({
  store,
  render: h => h(App)
}).$mount('#corporate')
